<template>
  <div class="violations-modal">
    <r-title>{{ title }}</r-title>
    <modal-create
      :source_id="sourceId"
      :source="source"
    />
  </div>
</template>

<script>
import { titles, sources } from '../../configs'

export default {
  components: {
    ModalCreate: () => import('./modal-create')
  },
  data: () => ({
    sources,
    titles
  }),
  computed: {
    title() {
      return this.titles.create
    },
    source() {
      return this.$store.state[this.sources.store][this.sources.field]
    },
    sourceId() {
      return this.source?.source_id || null
    }
  }
}
</script>

<style lang="scss" scoped>
.violations-modal {
  display: grid;
  grid-gap: 1rem;
  align-content: start;
}
</style>
